import Config from '../core/Config';

const { actionTrigger } = Config.get();

export const get = async (url, opts = {}) => {
    const { hostname, port, protocol } = window.location;
    const { params, ...fetchOpts } = opts;

    if (url.startsWith('/')) {
        // eslint-disable-next-line no-param-reassign
        url = `${protocol}//${hostname}${url}`;
    }

    // eslint-disable-next-line no-param-reassign
    url = new URL(url);

    if (port) {
        url.port = port;
    }

    if (params) {
        new URLSearchParams(params).forEach((value, key) => {
            url.searchParams.append(key, value);
        });
    }

    return fetch(url.toString(), {
        method: 'GET',
        mode: 'same-origin',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        },
        referrerPolicy: 'same-origin',
        ...fetchOpts
    });
};

export const post = async (url, opts = {}) => {
    let { csrfTokenValue } = Config.get();
    if (!csrfTokenValue) {
        csrfTokenValue = await get(`/${actionTrigger}/ly/csrf`)
            .then(res => res.json())
            .then(({ token }) => {
                Config.set('csrfTokenValue', token);
                return token;
            })
            .catch(error => {
                console.error(error);
            });
    }
    const { headers = {} } = opts;
    if (opts.body && !(opts.body instanceof FormData)) {
        opts.body = JSON.stringify(opts.body);
        headers['Content-Type'] = 'application/json';
    }

    const { hostname, port, protocol } = window.location;

    if (url.startsWith('/')) {
        // eslint-disable-next-line no-param-reassign
        url = `${protocol}//${hostname}${url}`;
    }

    if (port) {
        // eslint-disable-next-line no-param-reassign
        url = new URL(url);
        url.port = port;
        // eslint-disable-next-line no-param-reassign
        url = url.toString();
    }

    return fetch(url, {
        method: 'POST',
        mode: 'same-origin',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
            Accept: 'application/json',
            'X-CSRF-Token': csrfTokenValue,
            'X-Requested-With': 'XMLHttpRequest',
            ...headers
        },
        referrerPolicy: 'same-origin',
        ...opts
    });
};
